import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { spacing } = tokens;

const BrandIconVirus = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 48 48'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <defs>
                <style>{'.Virus_svg__cls-2{fill:#002664}'}</style>
            </defs>
            <path d='M15 25a5 5 0 105-5 5 5 0 00-5 5z' fill='#d7153a' />
            <path
                className='Virus_svg__cls-2'
                d='M17 9.5a1.5 1.5 0 10-1.5 1.5A1.5 1.5 0 0017 9.5zm5.5 7.5a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5zm-10 0a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5zm18 12a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5zM23 33.5a1.5 1.5 0 101.5-1.5 1.5 1.5 0 00-1.5 1.5zM37.5 35a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5z'
            />
            <path
                className='Virus_svg__cls-2'
                d='M47.43 40.1l-4.15-2a9.17 9.17 0 001.46-3.84l1.94.65A1.25 1.25 0 0047 35a1 1 0 001-.68 1 1 0 00-.63-1.27l-2.49-.83a10.5 10.5 0 00-.88-3.44l3.24-.78a1 1 0 10-.48-2L43 27c-.23-.35-.49-.7-.76-1l3.32-2.48a1 1 0 00.2-1.4 1 1 0 00-1.4-.2l-3.5 2.62a15.63 15.63 0 00-1.48-1.18l1.65-2.48a1 1 0 00-.28-1.39 1 1 0 00-1.38.28l-1.67 2.47-.25-.13c-.61-.31-1.19-.64-1.74-1l2.72-3.44a1 1 0 00-.16-1.4 1 1 0 00-1.41.16L34.05 20a23.85 23.85 0 01-2.26-1.9l3.35-2.62a1 1 0 10-1.23-1.57l-3.52 2.74c-.65-.73-1.25-1.47-1.81-2.21l4.54-3.63a1 1 0 00.16-1.41 1 1 0 00-1.41-.15l-4.45 3.56c-.53-.78-1-1.54-1.49-2.27L29.6 7.8a1 1 0 10-1.2-1.6l-3.57 2.68c-.34-.53-.69-1-1-1.48a5.46 5.46 0 00-.41-.4l3.73-3.73a1 1 0 000-1.42 1 1 0 00-1.41 0L22 5.59a10.86 10.86 0 00-3-1.54l1-2.73a1 1 0 10-1.9-.64l-1 2.88c-.33-.05-.67-.1-1-.12a11.39 11.39 0 00-3.14.21l-1-3a1 1 0 10-1.9.64L11 4.2a12.33 12.33 0 00-2 1l-3-4a1 1 0 10-1.6 1.2l3 4c-.37.31-.73.63-1.08 1-.12.13-.23.26-.35.38L1.62 4.22a1 1 0 00-1.4.16 1 1 0 00.16 1.4l4.43 3.55A9.81 9.81 0 003.8 13l-2.94.56a1 1 0 00-.8 1.16 1 1 0 001 .82h.19l2.56-.48a20.34 20.34 0 00.73 4.06l-4 2a1 1 0 00-.44 1.34A1 1 0 001 23a.93.93 0 00.45-.11L5.16 21a30.71 30.71 0 001.48 3.4l-5 1.65a1 1 0 00-.63 1.27A1 1 0 002 28a1.25 1.25 0 00.32 0l5.29-1.76c.37.65.77 1.3 1.19 1.94l-4.33 3.41A1 1 0 004.31 33a1 1 0 00.79.37 1 1 0 00.62-.22L10 29.77c.44.61.9 1.21 1.38 1.79 0 0-.09 0-.12.08l-2.83 2.8a1 1 0 000 1.42 1 1 0 00.71.29 1 1 0 00.71-.29l2.83-2.8A24.66 24.66 0 0014.55 35l-3 4.16a1 1 0 001.62 1.17l3-4.08c.49.38 1 .74 1.51 1.08l-1.76 5.78a1 1 0 00.67 1.25.93.93 0 00.29 0 1 1 0 001-.71l1.6-5.28c.65.37 1.31.72 2 1.05l-.84 3.34a1 1 0 00.62 1.24 1 1 0 001.21-.73l.75-3c.56.23 1.12.45 1.68.65v4.66a1 1 0 002 0v-4c.73.2 1.45.37 2.17.52V47a1 1 0 002 0v-4.61c.72.09 1.41.13 2.1.15v.06l3 4a1 1 0 00.8.4 1 1 0 00.6-.2 1 1 0 00.2-1.4l-2.2-2.94a12.22 12.22 0 003.33-.79l1.65 2.47a1 1 0 00.83.45 1 1 0 00.56-.17 1 1 0 00.3-1.42l-1.54-2.28a11.15 11.15 0 001.23-1l4.64 2.18a1 1 0 00.43.1 1 1 0 00.43-1.9zM7.71 8.71a10.62 10.62 0 017.54-3.3h.69A8.58 8.58 0 0122.2 8.6c.63.84 1.28 1.85 2 2.92 2.62 4.07 5.88 9.12 12.38 12.37 3.73 1.87 6.08 5 6.29 8.5a7.43 7.43 0 01-3.39 6.78c-5.68 3.78-19.12-.32-25.7-7.83S3.11 13.3 7.71 8.71z'
            />
        </svg>
    );
};

BrandIconVirus.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'xl', 'xxl']),
};
BrandIconVirus.defaultProps = {
    size: 'xl',
    focusable: false,
};
export default BrandIconVirus;
